import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import Navbar from "./components/Navbar";
import Numbers from "./components/Numbers";
import Support from "./components/Support";
import Video from "./components/Video";
import Vision from "./components/Vision";
import VisionCards from "./components/VisionCards";
import BankTransfers from "./components/BankTransfers";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <BankTransfers />
      <Video />
      <Vision />
      <VisionCards />
      <Support />
      <Numbers />
      <Footer />
    </div>
  );
}

export default App;
